import type { Column } from '@tanstack/react-table'
import type { CSSProperties } from 'react'

export interface TableLayoutSnapshot {
  tableWidth: number
  columnWidths: Record<string, number>
}

export function snapshotTableLayout(
  tableEl: HTMLTableElement,
  options?: { skipOverlayColumn?: boolean }
): TableLayoutSnapshot {
  const tableWidth = tableEl.getBoundingClientRect().width
  const headerCells = Array.from(tableEl.querySelectorAll('thead tr th'))
  const dataHeaderCells = options?.skipOverlayColumn ? headerCells.slice(1) : headerCells
  const columnWidths: Record<string, number> = {}

  dataHeaderCells.forEach(cell => {
    const columnId = cell.getAttribute('data-column-id')
    if (columnId) columnWidths[columnId] = cell.getBoundingClientRect().width
  })

  return { tableWidth, columnWidths }
}

/** Resolves a column's frozen (locked) width from a snapshot taken via `snapshotTableLayout`. */
export function getLockedColumnStyle<T>(
  columnId: string,
  column: Column<T, unknown>,
  columnWidths?: Record<string, number>
): CSSProperties | undefined {
  const locked = columnWidths?.[columnId]
  if (locked == null) return undefined
  const minSize = column.columnDef.minSize
  return { width: locked, minWidth: minSize ?? locked, maxWidth: locked }
}
